import 'webp-in-css/polyfill';
import animate from '../../templates/diagrams/diagrams.js';
import mainMenu from '../../components/header/header.js';
import clientsSlider from '../../templates/client-logos/client-logos.js';
import reviewsSlider from '../../templates/reviews/reviews.js';
import realizeIdeas from '../../templates/realize-ideas/realize-ideas.js';
import sponsor from './sponsor/sponsor.js';
import sponsorMobile from './sponsor/sponsor-mobile.js';
import branding from './branding/branding.js';
import events from './events/events.js';
import eventsSlider from '../../templates/events/events.js';
import casesSlider from '../../templates/cases/cases.js';
import { scrollToElement } from '../../scripts/scrollToElement.js';
import { scrollAnimate } from '../../scripts/scrollAnimate.js';
import initForm from '../../components/forms/form.js';
import privacyPolicy from '../../components/privacy-policy/privacy-policy.js';
import ModalForm from '../../components/forms/modal-form.js';
import cookie from '../../components/cookie/cookie.js';
import insertYear from '../../components/footer/footer.js';
import { init as initSentry } from '../../../common/Sentry.js';

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const disableToScrollAnchors = ['privacy-policy', 'error-modal'];

const anchors = document.querySelectorAll('a[href^="#"]');
for (let anchor of anchors) {
  anchor.addEventListener('click', (e) => {
    const elementId = anchor.getAttribute('href').substr(1);
    if (!disableToScrollAnchors.includes(elementId)) {
      e.preventDefault();
      scrollToElement(anchor.getAttribute('href').substr(1));
    }
  });
}

mainMenu();
clientsSlider();
reviewsSlider();
sponsorMobile();
branding();
scrollAnimate().init();
realizeIdeas();
eventsSlider();
casesSlider();
initForm();
privacyPolicy();
ModalForm();
cookie();
insertYear();
initSentry('en');

animate.add(document.querySelectorAll('.js-animate'));
sponsor(document.querySelector('.er_sponsor'), window);
events(document.querySelector('.events_section'), window);
